<script lang="ts">
	import { ChevronLeft, ChevronRight } from 'lucide-svelte';

	interface Props {
		breadcrumbs: {
			title: string;
			path?: string;
		}[];
	}

	let { breadcrumbs }: Props = $props();
</script>

{#if breadcrumbs.length > 1}
	<div class="w-full lg:hidden">
		{#each breadcrumbs.slice(-2, -1) as crumb}
			<a href={crumb.path} class="link body-bold inline-flex items-center">
				<ChevronLeft class="w-6" />
				{crumb.title}</a
			>
		{/each}
	</div>
{/if}

<div class="hidden w-full gap-2 text-sm lg:flex lg:items-center">
	<a href="/" class="crumb-link"> Home</a>
	{#each breadcrumbs as crumb, i}
		<ChevronRight class="w-5" />
		{#if i < breadcrumbs.length - 1}
			<a href={crumb.path} class="crumb-link"> {crumb.title}</a>
		{:else}
			<a href={crumb.path} class="font-medium"> {crumb.title}</a>
		{/if}
	{/each}
</div>

<style lang="postcss">
	@reference '../app.css';

	.crumb-link {
		@apply relative;
		&:after {
			content: '';
			@apply absolute bottom-0 left-0 h-[2px] w-full rounded;
		}
		&:hover {
			&:after {
				@apply bg-black;
			}
		}
	}
</style>
